import Image, { ImageProps } from 'next/legacy/image'

const labPlaceholder = require('@public/images/lab/lab_placeholder.svg')

const LabImageComponent: React.FC<ImageProps> = ({ src, ...props }) => (
  <Image src={src || labPlaceholder} {...props} />
)

export default LabImageComponent
